import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { PageHeader, Panel, Select } from "@/components/admin/ui";
import { RestockList } from "./RestockList";

const STATUSES = ["new", "reviewed", "approved", "ordered", "delivered", "completed"];

export default function RestockRequests() {
  const [items, setItems] = useState([]);
  const [stores, setStores] = useState([]);
  const [emps, setEmps] = useState([]);
  const [f, setF] = useState({ store_id: "", status: "", employee_id: "", priority: "", date_from: "", date_to: "" });

  useEffect(() => {
    api.get("/stores").then((r) => setStores(r.data));
    api.get("/employees").then((r) => setEmps(r.data)).catch(() => {});
  }, []);

  const load = useCallback(() => {
    const qs = Object.entries(f).filter(([, v]) => v).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
    api.get(`/restock-orders${qs ? `?${qs}` : ""}`).then((r) => setItems(r.data));
  }, [f]);
  useEffect(load, [load]);

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const counts = STATUSES.reduce((a, s) => ({ ...a, [s]: items.filter((i) => i.status === s).length }), {});

  return (
    <div className="p-6 lg:p-10">
      <PageHeader eyebrow="Company" title="Restock Requests" testId="restock-requests-title" subtitle={`${items.length} request${items.length !== 1 ? "s" : ""} · ${counts.new} new`}/>
      <div className="flex flex-wrap gap-2 mb-4">
        <Select value={f.store_id} onChange={set("store_id")} data-testid="filter-store"><option value="">All stores</option>{stores.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</Select>
        <Select value={f.status} onChange={set("status")} data-testid="filter-status"><option value="">All statuses</option>{STATUSES.map((s) => <option key={s} value={s}>{s[0].toUpperCase() + s.slice(1)} ({counts[s] || 0})</option>)}</Select>
        <Select value={f.employee_id} onChange={set("employee_id")} data-testid="filter-employee"><option value="">All employees</option>{emps.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}</Select>
        <Select value={f.priority} onChange={set("priority")} data-testid="filter-priority"><option value="">All priorities</option>{["low", "normal", "high", "urgent"].map((p) => <option key={p} value={p}>{p[0].toUpperCase() + p.slice(1)}</option>)}</Select>
        <Input type="date" value={f.date_from} onChange={set("date_from")} className="w-40" data-testid="filter-from"/>
        <Input type="date" value={f.date_to} onChange={set("date_to")} className="w-40" data-testid="filter-to"/>
      </div>
      <Panel className="overflow-hidden"><RestockList items={items} canApprove onChange={load} showStore/></Panel>
    </div>
  );
}
